import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { financeHomeRoute, HttpStatus } from 'config/Api.Config';
import useClaimJobPayment from './Finance.ClaimJobPayment.Hooks';
import FinanceClaimJobPaymentCancel from './components/Finance.ClaimJobPayment.Cancel';
import ClaimJobPaymentSendEmail from './components/Finance.ClaimJobPayment.SendEmail';
import ClaimJobPaymentList from './sections/Finance.ClaimJobPayment.List';

export const financeClaimJobPaymentIndexRoute = financeHomeRoute + '/claimJobPayment/:action?/:id?';
export default function FinanceClaimJobPaymentIndex() {
  const claimJobPaymentHook = useClaimJobPayment();

  if (!claimJobPaymentHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={claimJobPaymentHook}
        render={({ pageRouter }) => {
          return (
            <>
              <ClaimJobPaymentList />
              {pageRouter.params?.id && pageRouter?.params?.action === 'sendEmail' && <ClaimJobPaymentSendEmail />}
              {pageRouter.params?.id && pageRouter?.params?.action === 'cancel' && <FinanceClaimJobPaymentCancel />}
            </>
          );
        }}
      />
    </>
  );
}
